// Page-specific JS for the new homepage (fortnight variant).
//
// Manages autoplay videos on this page:
//
// 1. Pause/play based on viewport visibility. Saves CPU and battery on a page
//    with 5+ video loops — videos only decode while actually visible.
//
// 2. Resume after bfcache restore or tab focus change. Mobile browsers
//    (especially iOS Safari) don't re-evaluate the `autoplay` attribute on
//    bfcache restore, leaving paused videos stuck otherwise.

(function () {
  const videos = document.querySelectorAll('video[autoplay]');

  function playIfVisible(video) {
    const rect = video.getBoundingClientRect();
    const visible = rect.top < window.innerHeight && rect.bottom > 0;
    if (visible && video.paused) {
      video.play().catch(() => {});
    }
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target.paused) entry.target.play().catch(() => {});
          } else if (!entry.target.paused) {
            entry.target.pause();
          }
        });
      },
      { rootMargin: '50px' }
    );

    videos.forEach((video) => observer.observe(video));
  }

  document.addEventListener('pageshow', (event) => {
    if (event.persisted) videos.forEach(playIfVisible);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) videos.forEach(playIfVisible);
  });
})();
